import { fetchApi } from 'shared/functions';

export const uploadPortfolioUnified = async (payload, uploadType) => {
  const { file, portfolioName, portfolioId, uploadEntitiesViaIsin: uploadToISIN } = payload;
  const formData = new FormData();
  formData.append('file', file, file.name);
  if (uploadToISIN) formData.append('uploadEntitiesViaIsin', uploadToISIN);
  if (portfolioId) formData.append('portfolioId', portfolioId);
  if (portfolioName) formData.append('portfolioName', portfolioName);

  const url = `/user-profile/portfolios/upload/${uploadType}`;

  const params = {
    method: 'POST',
    body: formData,
  };

  return fetchApi(url, params, ['Content-Type']);
};
